import generateBasicEntityActions from "./generateBasicEntityActions";
import * as schemas from "../schemas";

const fiSpreadsheetActions = generateBasicEntityActions(
  "fiSpreadsheets",
  "fiSpreadsheet",
);

fiSpreadsheetActions.create = (spreadsheet) => {
  const { file, ...spreadsheetParams } = spreadsheet;
  return {
    API_CALL: {
      httpMethod: "POST",
      endpoint: "fiSpreadsheets",
      params: { fiSpreadsheet: spreadsheetParams },
      attachments: { file },
      schema: { fiSpreadsheet: schemas.fiSpreadsheet },
    },
  };
};

fiSpreadsheetActions.reimport = (id) => ({
  API_CALL: {
    httpMethod: "PUT",
    endpoint: `fiSpreadsheets/${id}/reimport`,
    schema: { spreadsheet: schemas.spreadsheet },
  },
});

export default fiSpreadsheetActions;
